import { apiRoot } from './ApiConfig'
import React, { useEffect, useState } from "react"
import { useLocation } from 'react-router-dom'
import { useT } from './i18n/LanguageContext'

import axios from "axios"

const PasswordChange = () => {
  const location = useLocation()
  const [passwordChangeKey, setPasswordChangeKey] = useState('')
  //const [userEmail, setUserEmail] = useState('')


  useEffect(() => {
    // URL paraméterek kezelése
    const queryParams = new URLSearchParams(location.search)
    const key = queryParams.get('password_change_key')
    if (key) {
      console.info("Key:",key)
      setPasswordChangeKey(key)
    }
  }, [location]);

  useEffect(() => {
    if ( passwordChangeKey.length>0 ) {
      console.info("passwordChangeKey after update:", passwordChangeKey)
    }
  }, [passwordChangeKey]);

  return (
    <div className="flex h-screen items-center justify-center bg-blue-50 p-20">
      <Form passwordChangeKey={passwordChangeKey} />
    </div>
  )
}

/*
██████   █████  ███████ ███████      ██████ ██   ██  █████  ███    ██  ██████  ███████ 
██   ██ ██   ██ ██      ██          ██      ██   ██ ██   ██ ████   ██ ██       ██      
██████  ███████ ███████ ███████     ██      ███████ ███████ ██ ██  ██ ██   ███ █████   
██      ██   ██      ██      ██     ██      ██   ██ ██   ██ ██  ██ ██ ██    ██ ██      
██      ██   ██ ███████ ███████      ██████ ██   ██ ██   ██ ██   ████  ██████  ███████ 
*/
const Form = (keyFromUrlObject) => {
  const t = useT()
  const passwordChangeKey = keyFromUrlObject.passwordChangeKey
  const [newPassword, setNewPassword] = useState("");
  const [newPasswordConfirm, setNewPasswordConfirm] = useState("")
  const [message, setMessage] = useState("");

  //const allowedPasswordCharsRegex = /^[A-Za-z0-9!@#$%^&*()_+\-=:,./]*$/
  const allowedPasswordCharsRegex = /^[A-Za-z0-9]*$/


  const handlePasswordChange = (e) => {
    const value = e.target.value;
    if (allowedPasswordCharsRegex.test(value)) {
      if ( e.target.id === "pwd1" ) {
        setNewPassword(value)
      }
      if ( e.target.id === "pwd2" ) {
        setNewPasswordConfirm(value)
      }
    }
  }
  const isStrongPassword = (password) => {
    return (
      password.length >= 12 &&
      /[A-Z]/.test(password) &&                 // Legalább egy nagybetű
      /[a-z]/.test(password) &&                 // Legalább egy kisbetű
      /[0-9]/.test(password) &&                 // Legalább egy számjegy
      allowedPasswordCharsRegex.test(password)   // Csak engedélyezett karaktereket tartalmaz
    )
  }

  
  
  
  const handleChangeMyPassword = async () => {
    if (newPassword.trim().length > 0) {
      if (newPassword !== newPasswordConfirm) {
        alert(t("auth.msg.passwordMismatch", "The passwords don't match!"))
        return
      }
      if ( !isStrongPassword(newPassword) ) {
        alert(t("userui.msg.invalidPassword", "Invalid password! At least 12 characters and must contain lowercase and uppercase letters and numbers."))
        return
      }
    } else {
      return
    }

    try {
      const response = await axios.post(apiRoot+"api/users/passwordChange", { passwordChangeKey: passwordChangeKey, password: newPassword })
      if ( response.data.success ) {
        setMessage(t("userui.pwchange.changed", "Your password is changed!"))
        setNewPassword(""); setNewPasswordConfirm("")
      } else {
        setMessage(t("userui.pwchange.invalidUrl", "The passwordChange URL is not valid"))
      }
    } catch (error) {
      setMessage(t("userui.msg.webserverError", "Webserver error!"));
    }
  }


  return (
    <div className="sm:w-full lg:w-1/2 p-6 bg-blue-200 rounded-lg shadow-md">
      <h2 className="text-2xl font-semibold text-blue-800 mb-4">{t("userui.pwchange.title", "VoxDoc passcode changer")}</h2>
      <label htmlFor="newPassword" className="block mb-1 text-sm font-medium text-blue-800">
        {t("auth.fields.passwordHint", "Password (At least 12 characters)")}
      </label>
      <label className="block mb-2 text-xs text-blue-600">
        {t("userui.fields.allowedChars", "Allowed characters: a-z, A-Z, 0-9")}
      </label>
      <input
        id="pwd1"
        type="password"
        placeholder={t("common.labels.password", "Password")}
        className="w-full p-3 mb-4 border border-blue-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
        value={newPassword}
        onChange={handlePasswordChange}
        onKeyDown={(e) => {
          if (e.key === " ") e.preventDefault()
        }}
      />
      <label htmlFor="newPasswordConfirm" className="block mb-2 text-sm font-medium text-blue-800">{t("userui.pwchange.confirmPasscode", "Confirm Passcode (6 digits. Example: 654987):")}</label>
      <input
        id="pwd2"
        type="password"
        placeholder={t("userui.pwchange.confirmPlaceholder", "Confirm Password")}
        className="w-full p-3 mb-4 border border-blue-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
        value={newPasswordConfirm}
        onChange={handlePasswordChange}
        onKeyDown={(e) => {
          if (e.key === " ") e.preventDefault()
        }}
      />
      <button
        onClick={handleChangeMyPassword}
        className="w-full p-3 bg-blue-600 text-white rounded hover:bg-blue-700 focus:ring-2 focus:ring-blue-400"
      >
        {t("userui.pwchange.submit", "Change my password")}
      </button>
      {message && <p className="mt-4 text-blue-700">{message}</p>}
    </div>
  )
}

export default PasswordChange
